import React from 'react';

import { ComponentProps } from './interfaces';
import * as Styled from './styled';

export const List: React.FC<ComponentProps> = ({ type, items, getProps }) => {
  const renderItems = items.map((item, i) => {
    return (
      <Styled.ItemContainer key={i} {...(getProps ? getProps(i) : {})}>
        {item}
      </Styled.ItemContainer>
    );
  });

  return (
    <Styled.Container>
      {type === 'disc' && <Styled.DiscListContainer>{renderItems}</Styled.DiscListContainer>}
      {type === 'number' && <Styled.NumberListContainer>{renderItems}</Styled.NumberListContainer>}
      {type === 'alpha' && <Styled.AlphaListContainer>{renderItems}</Styled.AlphaListContainer>}
    </Styled.Container>
  );
};

export default List;
